import React from 'react';
import icons from './../../../icons.svg';
import Button from '../../common/button';

const RefillPlanConfirmation = ({
  t,
  user,
  cabinet,
  replenishPlanActions,
  replenishPlan,
  planFailed,
  updateRefillStatus,
  setConfirmationOpen,
}) => {
  return cabinet.currentItemsLoading ? (
    <div className="loading-container">
      <svg className="loading">
        <use xlinkHref={`${icons}#icon-refresh`}></use>
      </svg>
    </div>
  ) : (
    <section className="replenishment">
      <div className="replenishment__popup replenishment__question">
        <div className="replenishment__popup-text replenishment__question-text">
          <span className="replenishment__popup-text-neutral">
            {t(
              replenishPlan?.plan?.length && planFailed
                ? 'cabinet:refill_warning_question'
                : 'cabinet:refill_question'
            )}
          </span>
        </div>
        <div className="replenishment__buttons">
          <Button
            text={t('common:yes')}
            action={() => {
              // Refill plan status is set to completed
              replenishPlanActions.updateStatus(
                cabinet.group,
                replenishPlan.id,
                'Completed',
                user.profile.name
              );
              // refetch the plan after the update
              replenishPlanActions.fetchPlan(cabinet.group, cabinet.deviceCode);

              updateRefillStatus();

              setConfirmationOpen(false);
            }}
            type="primary"
          />
          <Button
            text={t('common:no')}
            action={() => {
              // Refill plan status stays active
              setConfirmationOpen(false);
            }}
            type="primary"
          />
        </div>
        <div
          className="replenishment__popup-cancel"
          onClick={() => {
            // Refill plan status stays active
            setConfirmationOpen(false);
          }}
        >
          <span />
          <span />
        </div>
      </div>
    </section>
  );
};

export default RefillPlanConfirmation;
